import { useTranslation } from 'react-i18next';

// Utils
import cn from '@/utils/cn';

// Components
import Breadcrumb from '@/components/atoms/Breadcrumb/Breadcrumb';
import Heading from '@/components/atoms/Heading/Heading';
import Markdown from '@/components/atoms/Markdown/Markdown';
import Button from '@/components/atoms/Button/Button';

// Services
import { type BlocHeroType } from '@/services/blocksSchema';

// Other
import Vector from '@/assets/blocks/vector-shadow-grey-big.svg?react';

// Style
import styles from './BlocHero.module.css';

interface BlocHeroProps {
  bgImage?: BlocHeroType['bgImage'];
  title: BlocHeroType['title'];
  description?: BlocHeroType['description'];
  isButtonVisible?: BlocHeroType['isButtonVisible'];
}

function BlocHero({
  bgImage = null,
  title,
  description = null,
  isButtonVisible = null,
}: BlocHeroProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.relative}>
      {
        bgImage ? (
          <>
            <img
              src={bgImage.url}
              alt={bgImage.alternativeText || ''}
              className={styles.cover}
              draggable={false}
            />
            <div className={styles['cover-overlay']} />
          </>
        ) : null
      }
      
      <div className={styles.container}>
        <div className={styles.body}>
          <Breadcrumb color={bgImage ? 'light' : 'dark'} />
          <div className={cn([
            styles.body,
            !bgImage ? styles['text-half'] : null
          ])}>
            <Heading
              title={title}
              size='h1'
              Tag='h1'
              color={bgImage ? 'light' : 'dark'}
            />
            {
              description ? (
                <Markdown 
                  text={description}
                  className={cn([
                    styles.description,
                    bgImage ? ( styles['description-white'] ) : ( styles['description-dark'] )
                  ])}
                />
              ) : null
            }
            {
              isButtonVisible ? (
                <Button
                  title={t('signup-for-free')}
                  url='https://b2b.pneumaclic.com/register'
                  bgColor='red'
                />
              ) : null
            }
          </div>
        </div>
      </div>

      {
        !bgImage ? (
          <div className={styles.vector}>
            <Vector />
          </div>
        ) : null
      }
    </div>
  );
}

export default BlocHero;
